import { HTMLProps, ReactNode } from 'react';

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface HeadingProps extends HTMLProps<HTMLHeadingElement> {
    children: ReactNode;
    classNames?: string;
    styleAs?: HeadingTag;
    variant: HeadingTag;
}

const headingStyles: Record<HeadingTag, string> = {
    h1: 'text-3xl md:text-4xl',
    h2: 'text-2xl md:text-3xl',
    h3: 'text-xl sm:text-2xl',
    h4: 'text-lg sm:text-xl',
    h5: 'text-base sm:text-lg',
    h6: 'text-base'
};

export const Heading = ({ children, classNames = '', variant, styleAs = variant, ...props }: HeadingProps) => {
    const Component: HeadingTag = variant;
    const appliedStyle = headingStyles[styleAs];

    return (
        <Component className={`${appliedStyle} font-w-heading font-accent wrap-break-word text-balance max-w-full ${classNames}`} {...props}>
            {children}
        </Component>
    );
};
